import "core-js/modules/es.function.name.js";
/////////////////////////////////////////
// New in 0.4.0
export default {
  name: "WorldMap",
  data: function data() {
    return {
      center: {
        lat: 48.862725,
        lng: 2.287592
      },
      snazzy: [{
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{
          saturation: 36
        }, {
          color: "#000000"
        }, {
          lightness: 40
        }]
      }, {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [{
          visibility: "on"
        }, {
          color: "#000000"
        }, {
          lightness: 16
        }]
      }, {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{
          visibility: "off"
        }]
      }, {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{
          color: "#000000"
        }, {
          lightness: 20
        }]
      }, {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{
          color: "#000000"
        }, {
          lightness: 17
        }, {
          weight: 1.2
        }]
      }, {
        featureType: "administrative.country",
        elementType: "labels.text.fill",
        stylers: [{
          color: "#4f4f4f"
        }]
      }, {
        featureType: "administrative.country",
        elementType: "labels.text.stroke",
        stylers: [{
          color: "#ff0000"
        }, {
          visibility: "off"
        }]
      }, {
        featureType: "administrative.province",
        elementType: "labels.text.fill",
        stylers: [{
          color: "#4f4f4f"
        }]
      }, {
        featureType: "administrative.province",
        elementType: "labels.text.stroke",
        stylers: [{
          visibility: "off"
        }]
      }, {
        featureType: "administrative.locality",
        elementType: "labels.text.fill",
        stylers: [{
          color: "#b38149"
        }]
      }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
          color: "#000000"
        }, {
          lightness: 20
        }]
      }, {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{
          color: "#000000"
        }, {
          lightness: 21
        }]
      }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
          color: "#000000"
        }, {
          lightness: 17
        }]
      }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
          color: "#000000"
        }, {
          lightness: 29
        }, {
          weight: 0.2
        }]
      }, {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{
          color: "#000000"
        }, {
          lightness: 18
        }]
      }, {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{
          color: "#000000"
        }, {
          lightness: 16
        }]
      }, {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{
          color: "#000000"
        }, {
          lightness: 19
        }]
      }, {
        featureType: "water",
        elementType: "geometry",
        stylers: [{
          color: "#000000"
        }, {
          lightness: 17
        }]
      }, {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [{
          color: "#191919"
        }]
      }]
    };
  },
  methods: {
    emitEvent: function emitEvent(marker) {
      this.$emit("selectMarker", marker.position.name, marker.position.iso, marker.position.id_country);
    }
  },
  props: ["markers"]
};